import { makeAutoObservable } from "mobx";
import { IdentifiableMap, RSet } from "../../collections";
import { ProductInstanceHalves, } from "../ProductInstance";
export class HalvesCreatorState {
    constructor(params) {
        this.isSplit = true;
        this.productCategory = params.productCategory;
        this.commonModifierInstanceCreators = params.commonModifierInstanceCreators;
        this.commonCustomParameterInstanceCreators =
            params.commonCustomParameterInstanceCreators;
        this._firstHalf = params.firstHalf;
        this._secondHalf = params.secondHalf;
        this.creatorScopeProvider = params.creatorScopeProvider;
        makeAutoObservable(this);
    }
    get firstHalf() {
        return this._firstHalf;
    }
    get secondHalf() {
        return this._secondHalf;
    }
    get productTypeIds() {
        return RSet.fromIterable([this.firstHalf.productTypeId, this.secondHalf.productTypeId], {
            ignoreDuplicates: true,
        });
    }
    get commonModifierInstances() {
        return new IdentifiableMap(this.commonModifierInstanceCreators.raw.map((c) => c.modifierInstance));
    }
    get commonCustomParameterInstances() {
        return new IdentifiableMap(this.commonCustomParameterInstanceCreators.raw.map((c) => c.customParameterInstance));
    }
    get productInstanceParts() {
        return new ProductInstanceHalves({
            productCategory: this.productCategory,
            first: this.firstHalf.productInstancePart,
            second: this.secondHalf.productInstancePart,
        });
    }
    selectInferredDefaults() {
        this.commonModifierInstanceCreators.objects.forEach((m) => m.selectInferredDefaults());
        this.firstHalf.selectInferredDefaults();
        this.secondHalf.selectInferredDefaults();
    }
}
